/**
 * Shared types for the OAuth sign-in flow.
 *
 * A provider module returns a ProviderCredential — an ID token from Apple or
 * Google plus the nonce we sent into the request and (Apple-first-time-only) a
 * display name. The exchange step in oauth.ts hands that to the
 * oauth-exchange edge function, which returns a magic-link hash the client
 * redeems via supabase.auth.verifyOtp to finish the session.
 */

export type OAuthProvider = 'apple' | 'google'

export type ProviderCredential = {
  displayName?: string
  idToken: string
  // Must match the ID token's nonce claim. Apple JS and Google copy the
  // value we send them verbatim; native Apple embeds a SHA-256 hash.
  nonce?: string
}

export class OAuthCancelledError extends Error {
  constructor() {
    super('OAuth flow cancelled by user')
    this.name = 'OAuthCancelledError'
  }
}

export class OAuthUnavailableError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'OAuthUnavailableError'
  }
}
